import React, { useState } from 'react'
import { ButtonGroup, Col, Form, Row } from 'react-bootstrap'
import { radioBtn, radioBtn2, patientsData } from '../DashboardMockData'
import { formatValueByUnit } from '@utils/index'
import { DashboardUnits } from '@dataTypes/dashboard.types'

import '../DashboardStyle.css'

function ProgressBarFooter({ title }: { title: string }): React.ReactElement {
  const [selected, setSelected] = useState('')

  const handleChange = (newSelection: string): void => {
    setSelected(newSelection)
  }

  return (
    <Row className="progress-bar-footer mt-2">
      <hr className="m-0"></hr>
      <Col md={6}>
        <Form.Group className="mb-2 formGroup">
          <Form.Label className="text-start">Patients</Form.Label>
          <ButtonGroup className="w-100">
            {radioBtn.map((btn) => (
              <label
                key={`${btn.field}-${title}`}
                htmlFor={`${btn.field}-${title}`}
                className={`btn btn-outline-primary1 ${selected === btn.field ? 'checked' : ''}`}
              >
                <input
                  id={`${btn.field}-${title}`}
                  name={`${title}`}
                  type="radio"
                  className="btn-check"
                  onChange={() => handleChange(btn.field)}
                  checked={selected === btn.field}
                />
                {btn.title}
              </label>
            ))}
          </ButtonGroup>
        </Form.Group>
      </Col>
      <Col md={6}>
        <Form.Group className="mb-2 formGroup">
          <Form.Label>&nbsp;</Form.Label>
          <ButtonGroup className="w-100">
            {radioBtn2.map((btn) => (
              <label
                key={`${btn.field}-${title}`}
                htmlFor={`${btn.field}-${title}`}
                className={`btn btn-outline-primary1 ${selected === btn.field ? 'checked' : ''}`}
              >
                <input
                  id={`${btn.field}-${title}`}
                  name={`${title}`}
                  type="radio"
                  className="btn-check"
                  onChange={() => handleChange(btn.field)}
                  checked={selected === btn.field}
                />
                {btn.title}
              </label>
            ))}
          </ButtonGroup>
        </Form.Group>
      </Col>
      <Col md={12}>
        <Row>
          {patientsData.map((datum) => (
            <Col md={4} key={`${datum.label}`}>
              <div className="text-black">{`${datum.label}`}</div>
              <div className="text-black fw-bolder">{`${formatValueByUnit(datum.value, datum.unit as DashboardUnits)}`}</div>
            </Col>
          ))}
        </Row>
      </Col>
    </Row>
  )
}

export default ProgressBarFooter
